import {
  lineChartDataResiliation,
  lineChartDataSubscription,
  tableau_1,
  tableau_abonnement,
  tableau_resiliation,
} from "@/config/initData";
import {
  TKPI,
  TLineGraph,
  TTableauGlobal,
  TTableauGlobalResilie,
  TTableauSecteur,
} from "@/features/profile/types/profile.types";
import { DashboardAction } from "./dashboard.action";
import dashboardTypes from "./dashboard.types";

interface IDashboardReducerState {
  kpi_amount: TKPI;
  lineGraphResiliation: TLineGraph | null;
  lineGraphAbonnement: TLineGraph | null;
  tableauSecteur: TTableauSecteur | null;
  tableauGlobal: TTableauGlobal | null;
  tableauGlobalResilie: TTableauGlobalResilie | null;
  isLoadingDashboard: boolean;
  isLoadingLineChartResiliation: boolean;
  isLoadingLineChartAbonnement: boolean;
}

const INITIAL_STATE = {
  kpi_amount: {
    abonne: 0,
    montant: 0,
    date_maj: "",
    max_abon: 2022,
    max_resil: 2022,
    min_abon: 1956,
    min_resil: 1956,
  },
  lineGraphResiliation: lineChartDataResiliation,
  lineGraphAbonnement: lineChartDataSubscription,
  tableauSecteur: tableau_1.rows,
  tableauGlobal: tableau_abonnement.rows,
  tableauGlobalResilie: tableau_resiliation.rows,
  isLoadingDashboard: false,
  isLoadingLineChartResiliation: false,
  isLoadingLineChartAbonnement: false,
};

const dashboardReducer = (
  state: IDashboardReducerState = INITIAL_STATE,
  action: DashboardAction
): IDashboardReducerState => {
  switch (action.type) {
    case dashboardTypes.UPDATE_KPI:
      return {
        ...state,
        kpi_amount: action.payload,
      };
    case dashboardTypes.UPDATE_LINE_CHART_RESILIATION:
      return {
        ...state,
        lineGraphResiliation: action.payload,
      };
    case dashboardTypes.UPDATE_LINE_CHART_ABONNEMENT:
      return {
        ...state,
        lineGraphAbonnement: action.payload,
      };
    case dashboardTypes.UPDATE_TABLEAU_SECTEUR:
      return {
        ...state,
        tableauSecteur: action.payload,
      };
    case dashboardTypes.UPDATE_TABLEAU_GLOBAL:
      return {
        ...state,
        tableauGlobal: action.payload,
      };
    case dashboardTypes.UPDATE_TABLEAU_GLOBAL_RESILIE:
      return {
        ...state,
        tableauGlobalResilie: action.payload,
      };
    case dashboardTypes.IS_LOADING_DASHBOARD:
      return {
        ...state,
        isLoadingDashboard: action.payload,
      };

    case dashboardTypes.IS_LOADING_LINE_CHART_ABONNEMENT:
      return {
        ...state,
        isLoadingLineChartAbonnement: action.payload,
      };

    case dashboardTypes.IS_LOADING_LINE_CHART_RESILIATION:
      return {
        ...state,
        isLoadingLineChartResiliation: action.payload,
      };

    default:
      return state;
  }
};

export default dashboardReducer;
